<div class="theme-toggle-container">
  <p-button
    (onClick)="themeService.toggleTheme()"
    [icon]="themeService.isDark() ? 'pi pi-sun' : 'pi pi-moon'"
    [label]="themeService.isDark() ? 'Light' : 'Dark'"
    [severity]="themeService.isDark() ? 'secondary' : 'info'"
    [text]="true"
    [rounded]="true"
    size="small" />
</div>
